import React, { Component } from 'react'
import { connect } from 'react-redux'

// elemnents
import Row from '../../../../shared/elements/row'
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import Switch from '../../../../shared/elements/switch'
import Text from '../../../../shared/elements/text'
import Divider from '../../../../shared/elements/divider'
import Grid from '../../../../shared/elements/grid'

import { translation } from '../../../../utils/helpers'

import { getProductNumbersReport, getProductNumbers, saveProductNumbersReport, saveProductNumbers } from '../../../../actions/settings'

class ProductNumbers extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ShopId: 0,
      UseOwnProductNumbers: false,
      WorkHourAEProduct: null,
      TotalPriceProduct: null,
      ChainUseStandardProductNumbers: true,
      ProductNumber: []
    }

    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getProductNumbers()
  }

  componentDidUpdate (oldProps) {
    if (oldProps.accountingSystem !== this.props.accountingSystem) {
      this.getProductNumbers()
    }
  }

  getProductNumbers () {
    if (this.props.section === 'report') {
      this.props.getProductNumbersReport().then(res => {
        this.setState({
          ShopId: res.data.ShopId,
          UseOwnProductNumbers: res.data.UseOwnProductNumbers,
          WorkHourAEProduct: res.data.WorkHourAEProduct,
          TotalPriceProduct: res.data.TotalPriceProduct,
          ChainUseStandardProductNumbers: res.data.ChainUseStandardProductNumbers,
          ProductNumber: res.data.ProductNumber
        })
      }, (err) => {
        console.log(err)
      })
    } else {
      this.props.getProductNumbers(this.props.auth.user.ShopId).then(res => {
        this.setState({
          ShopId: res.data.ShopId,
          UseOwnProductNumbers: res.data.UseOwnProductNumbers,
          ChainUseStandardProductNumbers: res.data.ChainUseStandardProductNumbers,
          ProductNumber: res.data.ProductNumber
        })
      }, (err) => {
        console.log(err)
      })
    }
  }

  onChange (e) {
    e.persist()
    if (e.target.name === 'UseOwnProductNumbers') {
      this.setState({
        ...this.state,
        [e.target.name]: e.target.checked
      }, () => {
        this.onBlur(e)
      })
    } else {
      if (e.target.name.startsWith('PType')) {
        let id = e.target.name.substring(5)
        let index = 0
        if (this.props.section === 'report') {
          index = this.state.ProductNumber.findIndex(x => x.ProductNumberId === parseInt(id))
        } else {
          index = this.state.ProductNumber.findIndex(x => x.PType === parseInt(id))
        }
        let numbers = this.state.ProductNumber
        numbers[index].PNumber = e.target.value
        numbers[index].PExternalName = ''
        this.setState({
          ...this.state,
          ProductNumber: numbers
        })
      } else if (e.target.name === 'WorkHourAEProduct' || e.target.name === 'TotalPriceProduct') {
        this.setState({
          ...this.state,
          [e.target.name]: e.target.value || ''
        })
      }
    }
  }

  onBlur (e) {
    if (this.props.section === 'report') {
      this.props.saveProductNumbersReport(this.state).then((res) => {
        this.setState({
          ...this.state,
          WorkHourAEProduct: res.data.WorkHourAEProduct,
          TotalPriceProduct: res.data.TotalPriceProduct,
          ProductNumber: res.data.ProductNumber
        })
        // Toastr (replace dict. key)
        // window.toastr.success(translation('1724'), translation('13424'))
      }, () => {
        // Toastr (replace dict. key)
        window.toastr.error(translation('1725'), translation('216'))
      })
    } else {
      this.props.saveProductNumbers(this.state).then((res) => {
        this.setState({
          ...this.state,
          ProductNumber: res.data.ProductNumber
        })
        // Toastr (replace dict. key)
        // window.toastr.success(translation('1724'), translation('13424'))
      }, () => {
        // Toastr (replace dict. key)
        window.toastr.error(translation('1725'), translation('216'))
      })
    }
  }

  getLabelText (val) {
    if (this.props.section === 'report') {
      return val.PType
    }

    let isBodyShop = this.props.auth.departmentType === 1
    let labelText = ''
    switch (val.PType) {
      case 1:
        labelText = translation('416')
        break
      case 2:
        labelText = isBodyShop ? translation('15155') : translation('13339')
        break
      case 3:
        labelText = translation('417')
        break
      case 4:
        labelText = translation('1396')
        break
      case 5:
        labelText = translation('15297')
        break
      case 6:
        labelText = isBodyShop ? translation('660') : translation('15298')
        break
      case 7:
        labelText = translation('416')
        break
      case 8:
        labelText = translation('13339')
        break
      case 9:
        labelText = translation('637')
        break
      case 10:
        labelText = translation('15154')
        break
      case 11:
        labelText = translation('1396')
        break
      case 12:
        labelText = translation('15297')
        break
      case 13:
        labelText = translation('15298')
        break
      default:
        break
    }
    return labelText
  }

  renderProductNumberOther (val, key) {
    let labelText = this.getLabelText(val)

    return (
      <Grid spacing='1' align='center' cols={[2, 1]} key={'pnum_' + key}>
        <span>{labelText}</span>
        <Text size='m' name={'PType' + (this.props.section === 'report' ? val.ProductNumberId : val.PType)} value={val.PNumber} onChange={this.onChange} onBlur={this.onBlur} />
      </Grid>
    )
  }

  renderProductNumberTFSO (val, key) {
    let labelText = this.getLabelText(val)
    let showIcon = (val.PExternalName !== null && val.PExternalName !== '') ? true : null

    return (
      <Grid spacing='1' align='center' cols={[2, 1, 2]} key={'pnum_' + key}>
        <span>{labelText}</span>
        <Text size='m' name={'PType' + (this.props.section === 'report' ? val.ProductNumberId : val.PType)} value={val.PNumber} onChange={this.onChange} onBlur={this.onBlur} showValidationIcon={showIcon} />
        <span>{val.PExternalName}</span>
      </Grid>
    )
  }

  render () {
    if (this.state.ChainUseStandardProductNumbers === true) return null
    if (this.props.section === 'report') {
      return this.renderProductNumbersReports()
    }
    return this.renderProductNumbersOther()
  }

  renderProductNumbersOther () {
    let isTFSO = this.props.accountingSystem === 5
    return (
      <Row>
        <Col span={this.state.UseOwnProductNumbers ? (isTFSO ? 3 : 2) : 1}>
          <Panel title={translation('18366')} helpText={translation('15307') + ' ' + translation('15308')}>
            <Switch labelText={translation('15296')} name='UseOwnProductNumbers' checked={this.state.UseOwnProductNumbers} onChange={this.onChange} />
            {this.state.UseOwnProductNumbers && (
              <div>
                <Divider noLine />
                {this.state.ProductNumber.map((val, key) => isTFSO ? this.renderProductNumberTFSO(val, key) : this.renderProductNumberOther(val, key))}
              </div>
            )}
          </Panel>
        </Col>
      </Row>
    )
  }

  renderProductNumbersReports () {
    return (
      <Row>
        <Col span={this.state.UseOwnProductNumbers ? 2 : 1}>
          <Panel title={translation('18365')} helpText={translation('15307') + ' ' + translation('15308')}>
            <Switch labelText={translation('15296')} name='UseOwnProductNumbers' checked={this.state.UseOwnProductNumbers} onChange={this.onChange} />
            {this.state.UseOwnProductNumbers && (
              <div>
                <Divider noLine />
                <Grid spacing='1' align='center' cols={[2, 1]} key={'pnum_ae'}>
                  <span>{translation(18385)}</span>
                  <Text size='m' name={'WorkHourAEProduct'} value={this.state.WorkHourAEProduct} onChange={this.onChange} onBlur={this.onBlur} />
                </Grid>
                {this.state.ProductNumber.map((val, key) => this.renderProductNumberOther(val, key))}
                <Grid spacing='1' align='center' cols={[2, 1]} key={'pnum_tp'}>
                  <span>{translation(15298)}</span>
                  <Text size='m' name={'TotalPriceProduct'} value={this.state.TotalPriceProduct} onChange={this.onChange} onBlur={this.onBlur} />
                </Grid>
              </div>
            )}
          </Panel>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getProductNumbersReport, getProductNumbers, saveProductNumbersReport, saveProductNumbers })(ProductNumbers)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Invoicing/ProductNumbers/index.js